export default function getExtensionName(ext) {
    switch(ext) {
        case 'wmv':
        case 'mkv':
        case 'mov':
        case 'mp4': return 'video'
        case 'wav':
        case 'ogg':
        case 'mp3': return 'audio'
        case 'pdf': return 'pdf_file'
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'bmp':
        case 'svg':
        case 'gif': return 'image'
        case 'zip':
        case 'rar':
        case 'gzip':
        case 'tz': return 'compressed_file'
        case 'xlsx':
        case 'xls': return 'excel_file'
        case 'docx':
        case 'txt':
        case 'doc': return 'document'
        case 'pptx':
        case 'ppt': return 'powerpoint_file'

        default: return 'file'
    }
}
